import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { User, Lock, Loader2, LogIn } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";

const UserLogin = () => {
  const { userLogin } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [habboName, setHabboName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await userLogin(habboName.trim(), password);
      toast({ title: "Eingeloggt", description: `Hallo ${habboName}` });
      navigate("/profil");
    } catch (err) {
      toast({ title: "Fehler", description: err?.response?.data?.detail || "Login fehlgeschlagen", variant: "destructive" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-md px-4 py-20">
      <div className="rounded-2xl border border-white/10 bg-[#0f141b] p-8">
        <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-[#9d7bff]">
          <LogIn className="h-4 w-4" /> Habthek
        </div>
        <h1 className="mt-1 text-2xl font-bold text-white">Einloggen</h1>
        <p className="mt-2 text-sm text-zinc-400">Melde dich mit deinem Habbo-Account an.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <div className="relative">
            <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
            <Input value={habboName} onChange={(e) => setHabboName(e.target.value)} placeholder="Habbo-Name" className="pl-9 bg-[#10141b] border-white/10 text-zinc-200" />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passwort" className="pl-9 bg-[#10141b] border-white/10 text-zinc-200" />
          </div>
          <Button type="submit" disabled={busy} className="btn-primary w-full rounded-lg py-2 text-sm font-semibold">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            Einloggen
          </Button>
        </form>
        <div className="mt-4 text-center text-sm text-zinc-500">
          Noch keinen Account? <Link to="/registrieren" className="text-[#b39bff] hover:text-white">Registrieren</Link>
        </div>
      </div>
    </section>
  );
};

export default UserLogin;
